import { Dashboard, Settings, SystemManagement, Seeker, Users, Subscriptions } from "./Svg";

export const menu = [
  {
    name: "Dashboard",
    path: "/",
    Svg: Dashboard,
    subMenu: [],
    highlight: ["/my-profile", "/change-password"],
    subHighlight: [],
  },
  {
    name: "User Management",
    Svg: Users,
    subMenu: [
      {
        name: "Athletes",
        path: "/athletes",
        highlight: ["/athletes/add"],
        subHighlight: [
          "/athletes/view",
          "/athletes/edit",
          "/athletes/change-password",
        ],
      },
      {
        name: "Coaches",
        path: "/coaches",
        highlight: ["/coach/add"],
        subHighlight: ["/coach/view", "/coach/edit", "/coach/change-password"],
      },
      {
        name: "Clubs",
        path: "/clubs",
        highlight: ["/club/add"],
        subHighlight: ["/club/view", "/club/edit", "/club/change-password"],
      },
    ],
    highlight: ["/athletes"],
    subHighlight: [
      "/athletes/add",
      "/athletes/edit",
      "/athletes/view",
      "/coach/add",
      "/coach/edit",
      "/coach/view",
      "/club/add",
      "/club/edit",
      "/club/view",
      "/club/change-password",
      "/coach/change-password",
    ],
  },
  {
    name: "Sports Management",
    path: "/sports",
    Svg: SystemManagement,
    subMenu: [],
    highlight: ["/sport/add"],
    subHighlight: [
      // "/sport/view",
      "/sport/edit",
    ],
  },
  // {
  //   name: "Subscriptions",
  //   path: "/subscriptions",
  //   Svg: Subscriptions,
  //   subMenu: [],
  //   highlight: ["/subscription/add"],
  //   subHighlight: ["/subscription/edit"],
  // },
  {
    name: "Subscription Management",
    Svg: Subscriptions,
    subMenu: [
      {
        name: "Plans",
        path: "/plans",
        highlight: ["/plan/add"],
        subHighlight: ["/plan/edit"],
      },
      {
        name: "Subscriptions",
        path: "/subscriptions",
        highlight: ["/subscription/add"],
        subHighlight: ["/subscription/edit"],
      },
      {
        name: "Transactions",
        path: "/transactions",
        highlight: ["/transactions/add"],
        subHighlight: ["/transactions/view"],
      },
    ],
    highlight: ["/plan/add"],
    subHighlight: ["/plan/edit"],
  },
  {
    name: "System Management",
    Svg: SystemManagement,
    subMenu: [
      {
        name: "Home Page Management",
        subMenu: [
          {
            name: "Banner",
            path: "/home/banner",
            highlight: ["/home/banner"],
            subHighlight: ["/home/banner"],
          },
          {
            name: "Roles",
            path: "/home/roles",
            highlight: ["/home/role/add"],
            subHighlight: ["/home/role/edit"],
          },
        ],
        highlight: ["/home/role/add", "/home/banner"],
        subHighlight: ["/home/role/add", "/home/role/edit"],

      },
      {
        name: "Features",
        path: "/features",
        highlight: ["/feature/add"],
        subHighlight: [
          "/feature/edit",
        ],
      },
      {
        name: "About Us",
        subMenu: [
          {
            name: "Teams",
            path: "/about-us/teams",
            highlight: ["/about-us/team/add"],
            subHighlight: ["/about-us/team/edit"]
          },
          {
            name: "Contact Us",
            path: "/contact-us",
            highlight: ["/contact-us", "/setting/prefix/Contact"],
            subHighlight: ["/setting/prefix/Contact"],
          },
        ],
        highlight: ["/about-us/teams", "/about-us/team/add"],
        subHighlight: ["/about-us/team/edit"]
      },
      {
        name: "Resources",
        highlight: ["/resources/video", "/resources/video/add", "/resources/document/add"],
        subHighlight: [],
        subMenu: [
          {
            name: "Videos",
            path: "/resources/video",
            highlight: ["/resources/video/add"],
            subHighlight: ["/resources/video/edit"],
          },
          {
            name: "Documents",
            path: "/resources/document",
            highlight: ["/resources/document/add"],
            subHighlight: ["/resources/document/edit"],
          },
        ],
      },
      {
        name: "Getting Started",
        highlight: ["/getting-started/guide-for-sport-organization", "/getting-started/guide-for-sport-organization/add", "/getting-started/guide-for-coach/scenario-1/add", "/getting-started/guide-for-athlete/add", "/getting-started/guide-for-coach/scenario-1", "/getting-started/guide-for-coach/scenario-2", "/getting-started/guide-for-athlete"],
        subHighlight: ["/getting-started/guide-for-coach/scenario-2/add"],
        subMenu: [
          {
            name: "Guide for Sport Organization",
            path: "/getting-started/guide-for-sport-organization",
            highlight: ["/getting-started/guide-for-sport-organization/add"],
            subHighlight: ["/getting-started/guide-for-sport-organization/edit"],
          },
          {
            name: "Guide for Coach Scenario 1",
            path: "/getting-started/guide-for-coach/scenario-1",
            highlight: ["/getting-started/guide-for-coach/scenario-1/add"],
            subHighlight: ["/getting-started/guide-for-coach/scenario-1/edit"],
          },

          {
            name: "Guide for Coach Scenario 2",
            path: "/getting-started/guide-for-coach/scenario-2",
            highlight: ["/getting-started/guide-for-coach/scenario-2/add"],
            subHighlight: ["/getting-started/guide-for-coach/scenario-2/edit"],
          },
          {
            name: "Guide for Athlete",
            path: "/getting-started/guide-for-athlete",
            highlight: ["/getting-started/guide-for-athlete/add"],
            subHighlight: ["/getting-started/guide-for-athlete/edit"],
          },
        ],
      },
      {
        name: "Cms Pages",
        path: "/cms",
        highlight: ["/cms/add"],
        subHighlight: ["/cms/view", "/cms/edit"],
      },
      {
        name: "Currencies",
        path: "/currencies",
        highlight: ["/currency/add"],
        subHighlight: ["/currency/edit"],
      },

      {
        name: "Seo Pages",
        path: "/seo-pages",
        highlight: ["/seo-page/add"],
        subHighlight: ["/seo-page/edit"],
      },
      {
        name: "Email Templates",
        path: "/email-template",
        highlight: ["/email-template/add"],
        subHighlight: ["/email-template/edit"],
      },
      {
        name: "Email Logs",
        path: "/email-logs",
        highlight: [],
        subHighlight: [],
      },
      {
        name: "FAQs",
        path: "/faq",
        highlight: ["/faq/add"],
        subHighlight: ["/faq/edit", "/faq/view"],
      },
      {
        name: "System Images",
        path: "/system-images",
        highlight: ["/system-images", "/system-images/add"],
        subHighlight: ["/system-images/edit"],
      },
      {
        name: "RPE Color Code",
        path: "/rpe-color-codes",
        highlight: ["/rpe-color-codes"],
        subHighlight: ["/rpe-color-codes"],
      },
      {
        name: "Language Setting",
        path: "/language-setting",
        highlight: ["/language-setting"],
        subHighlight: ["/language-setting"],
      },

    ],
    highlight: ["/setting/prefix/Payment",
      "/system-images/add",
      "/home/banner",
      "/home/roles",
      "/features",
      "/about-us/teams",
      "/contact-us",
      "/resources/video",
      "/resources/document",
      "/getting-started/guide-for-sport-organization",
      "/getting-started/guide-for-athlete",
      "/home/role/add",
      "/feature/add",
      "/about-us/team/add",
      "/setting/prefix/Contact",
      "/resources/video/add",
      "/resources/document/add",
      "/getting-started/guide-for-sport-organization/add",
      "/getting-started/guide-for-athlete/add",
      "/getting-started/guide-for-coach/scenario-1",
      "/getting-started/guide-for-coach/scenario-2",
      "/getting-started/guide-for-coach/scenario-1/add",
      "/getting-started/guide-for-coach/scenario-2/add"
    ],
    subHighlight: ["/system-images/edit", "/seo-page/edit", "/home/role/edit", "/feature/edit"],
  },
  {
    name: "Settings",
    Svg: Settings,
    subMenu: [
      {
        name: "Site Setting",
        path: "/setting/prefix/Site",
        highlight: [],
        subHighlight: [],
      },
      {
        name: "Reading Setting",
        path: "/setting/prefix/Reading",
        highlight: [],
        subHighlight: [],
      },
      {
        name: "Social Setting",
        path: "/setting/prefix/Social",
        highlight: [],
        subHighlight: [],
      },
      {
        name: "Payment Gateway Setting",
        path: "/setting/prefix/PaymentGateway",
        highlight: [],
        subHighlight: [],
      },
      {
        name: "Pilot Account Setting",
        path: "/setting/prefix/PilotAccount",
        highlight: [],
        subHighlight: [],
      },
    ],
    highlight: ["/setting", "/setting/add", "/employee-count/add"],
    subHighlight: ["/setting/edit", "/employee-count/edit"],
  },
];
